import { render, staticRenderFns } from "./asset-tab-movimentacoes.vue?vue&type=template&id=1ace6622&"
import script from "./asset-tab-movimentacoes.vue?vue&type=script&lang=js&"
export * from "./asset-tab-movimentacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ace6622')) {
      api.createRecord('1ace6622', component.options)
    } else {
      api.reload('1ace6622', component.options)
    }
    module.hot.accept("./asset-tab-movimentacoes.vue?vue&type=template&id=1ace6622&", function () {
      api.rerender('1ace6622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/details-asset/asset-tab-movimentacoes.vue"
export default component.exports